import React from 'react';
import classNames from 'classnames';
import s from './Footer.scss';
export const FooterLogo = ({ brand, showNonBetaEditorXLogo, }) => (React.createElement("div", { className: s.footerLogoWrapper, "data-hook": "footer-logo" },
    React.createElement("div", { "data-hook": `footer-logo-${brand}`, className: classNames(s.logoSvg, brand, {
            [s.newLogo]: !!showNonBetaEditorXLogo,
        }) })));
//# sourceMappingURL=FooterLogo.js.map